<template>
	<ion-page>
		<spot-header :title="pageTitle + ' ' + (!tablesData || !tablesData.currentProject ? '' : tablesData.currentProject.name)" :canGoHome="false" :canGoBack="true" @pressedGoHome="$router.push('/home')" @pressedGoBack="exitPackages"></spot-header>

		<ion-content :fullscreen="true"> <!--v-if="isActive"-->
			<ion-progress-bar type="indeterminate" v-if="!isActive"></ion-progress-bar>
			<div id="actionArea" v-else>
				<web-socket-reader crReplacedChar="|" @readedBarcode="onReadedBarcode" @readedTag="onReadedTag" @readerError="onReaderError"></web-socket-reader>
				<spot-button
					:ref="fields[field.shipping].name"
					:text="fields[field.shipping].text"
					:enabled="itemsSelected.length>0"
					:size="fields[field.shipping].size"
					:fill="fields[field.shipping].fill"
					:icon="fields[field.shipping].icon"
					:expand="fields[field.shipping].expand"
					:color="fields[field.shipping].color"
					@clicked="markPackagesAsShipped">
				</spot-button>
				<ion-item>
					<spot-input
						:ref="fields[field.search].name"
						:label="fields[field.search].text"
						:allignLabel="fields[field.search].allignLabel"
						:required="fields[field.search].required"
						:placeholder="fields[field.search].placeholder"
						:enabled="true"
						:value="fields[field.search].value"
						:type="fields[field.search].inputType"
						:clearInput="true"
						@textChanged="changedSearch">
					</spot-input>
				</ion-item>
				<ion-progress-bar type="indeterminate" v-if="!tablesData.packages"></ion-progress-bar> <!-- v-if="!tablesData.projectRows" -->
				<EasyDataTable :class="{disabled: !isSupervisor}"
					v-model:items-selected="itemsSelected"
					:headers="headers"
					:items="tablesData.packages"
					:sort-by="sortBy"
					:sort-type="sortType"
					:search-field="searchFields"
					:search-value="fields[field.search].value"
					:empty-message="noItemsText"
					:rows-items="[10, 25, 50, 100, 200, 500]"
					:rows-per-page="100"
					alternating
					multi-sort> <!-- :items="tablesData.projectRows" show-index -->
				</EasyDataTable>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.debug">
				<div>Test Area</div>
				<spot-button
					fill="outline"
					size="large"
					color="primary"
					:enabled="true"
					text="Simulate Scan"
					@clicked="onReadedBarcode('1111111111111','barcode')">
				</spot-button>
				<div v-for="field in fields" :key="field.id">
					{{ field.name }} = {{ field.value }}
				</div>
			</div>
		</ion-content>

	</ion-page>
</template>

<style scoped>
.disabled {
	pointer-events: none;
	opacity: 0.7;
}
</style>

<script>
import { /*IonButton, IonCard, IonCardContent, */IonContent, /*IonIcon, */IonItem, /*IonModal, */IonPage, IonProgressBar, /*IonTextarea, IonTitle, IonToolbar*/ } from '@ionic/vue';
import { defineComponent, ref } from 'vue';
import SpotButton from '../components/SpotButton.vue';
import SpotInput from '../components/SpotInput.vue';
import SpotHeader from "../components/SpotHeader.vue";
import WebSocketReader from '../components/WebSocketReader.vue';
import { /* checkUserSession, */ confirmYesNo /*, insertValue*/, settings, showMsgError, showMsgInfo, showMsgWarning, writeLog } from '../plugins/common.js';
import { getProject, searchPackages, tablesData, updatePackage } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "ManagePackages",
		props: {
			pageTitle: { type: String, default: 'Carica Colli di' },
			noItemsText: { type: String, default: 'Nessun Collo presente' },
			confirmText: { type: String, default: 'Conferma' },
			supervisorRoleText: { type: String, default: 'supervisore' },
			messageSearchPackageTitle: { type: String, default: 'Ricerca Collo' },
			messageSearchPackageNotFound: { type: String, default: 'Collo non trovato oppure già chiuso e spedito!' },
			messageTitleCheckTAG: { type: String, default: 'Controllo TAG' },
			warnMultipleTAG: { type: String, default: 'Letto più di un TAG. Avvicinarsi solo al TAG da leggere e riprovare' },
			warnInavlidTAG: { type: String, default: 'TAG letto solo in parte. Riprovare a leggere' },
			confirmUnselectItem: { type: String, default: 'Confermi di voler escludere il collo selezionato?' },
			messageTitleReader: { type: String, default: 'Lettura Barcode/TAG' },
			errorReadingReader: { type: String, default: 'Errore nella lettura del barcode/tag' },
			messageTitleShipping: { type: String, default: "Carico Camion" },
			successSaveMessage: { type: String, default: "Carico camion avvenuto correttamente. Colli caricati: " },
		},
		components: {
			IonPage,
			IonContent,
			IonProgressBar,
			IonItem,
			// IonButton,
			// IonIcon,
			SpotHeader,
			SpotInput,
			SpotButton,
			WebSocketReader,
		},
		data: () => ({
			isActive: null,
			field: {
				shipping: 0,
				search: 1,
			},
			fields: [
				{ id: 0, name: 'shipping', text: 'Carica selezionati', enabled: null, inputType: 'button', size: 'default', fill: 'solid', expand: 'block', icon: 'bagAdd', color: 'primary' },
				{ id: 1, name: 'search', text: 'Cerca: ', allignLabel: true, placeholder: 'Cerca Collo', inputType: 'text', defaultValue: '', value: null, required: false, refField: null },
			],
			searchFields: ['name'],
			headers: [
				{ text: 'Name', value: 'name', sortable: true },
			],
			sortType: ['asc'],
			sortBy: ['incremental'],
			actionDbCreate: null,
			isSupervisor: false,
			isIncoming: null,
			isOutgoing: null,
			isPicking: null,
			isRevision: null,
			isLocked: null,
			projectId: null,
			documentId: null,
			lastBarcode: null,
			lastTag: null,
			settings,
			// checkUserSession,
			confirmYesNo,
			showMsgError,
			showMsgInfo,
			showMsgWarning,
			writeLog,
			getProject,
			searchPackages,
			updatePackage,
			tablesData,
		}),
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			this.setDefault();
			await this.getAllTablesData();
			this.isActive = true;
		},
		ionViewWillLeave() {
			this.itemsSelected = [];
			this.isActive=false;
		},
		computed: {
		},
		setup() {
			const itemsSelected = ref([]);
			return {
				itemsSelected,
			};
		},
		methods: {
			// Settings & StartUp
			getUrlParamsAndQuery() {
				this.isIncoming = (/true/i).test(this.$route.query.incoming);
				this.isOutgoing = (/true/i).test(this.$route.query.outgoing);
				this.isPicking = (/true/i).test(this.$route.query.picking);
				this.isRevision = (/true/i).test(this.$route.query.revision);
				this.isLocked = (/true/i).test(this.$route.query.locked);
				this.projectId = this.$route.params.id;
			},
			setDefault() {
				this.fields.forEach(element => element.value = element.defaultValue);
				this.actionDbCreate = null;
				this.isSupervisor = this.checkRole();
				this.lastBarcode = null;
				this.lastTag = null;
			},
			// Database
			async getAllTablesData() {
				await this.getProject(this.projectId);
				// this.tablesData.projectRows = [];
				// this.tablesData.packages = [];
				await this.searchPackages(this.projectId, true, false);
			},
			// Actions
			async onReadedBarcode(barcode, type, gs1Data = null) {
				this.lastBarcode = barcode;
				this.writeLog(barcode, type, gs1Data);
				await this.committedBarcode();
			},
			async onReadedTag(tag,type) {
				this.lastTag = tag;
				this.writeLog(tag, type);
				await this.committedTag();
			},
			onReaderError(data,error) {
				this.showMsgError(data, error);
				this.showMsgWarning(this.messageTitleReader, this.errorReadingReader);
			},
			changedSearch(value) {
				this.fields[this.field.search].value = value;
			},
			async markPackagesAsShipped() {
				for(const element of this.itemsSelected) {
					await this.updatePackage(element.id, this.prepareUpdatePackage(new Date().toISOString()), false);
				}
				this.showMsgInfo(
					this.messageTitleShipping,
					this.successSaveMessage + "&nbsp" + this.itemsSelected.length);
				this.exitPackages();
			},
			prepareUpdatePackage(date) {
				let myRecord = {
					package: {
						shipped: true,
						shipping_date: date,
					}
				};
				return myRecord;
			},
			checkRole() {
				let ret = false;
				this.tablesData.currentUser.roles.forEach(element => {if (element.name.toLowerCase() == this.supervisorRoleText.toLowerCase()) ret=true});
				return ret;
			},
			changedBarcode(value) {
				this.lastBarcode = value;
			},
			async committedBarcode() {
				let foundElement = null;
				this.tablesData.packages.some(element => {
					if (element.name == this.lastBarcode) {
						foundElement = element;
						return true;
					}
				});
				if (!foundElement) {
					this.showMsgWarning(this.messageSearchPackageTitle, this.messageSearchPackageNotFound);
				}
				else {
					/*
					if (!this.itemsSelected.includes(foundElement)) {
						this.itemsSelected.push(foundElement);
					}
					*/
					const index = this.itemsSelected.indexOf(foundElement);
					if (index > -1) {
						let canRemove = false;
						await this.confirmYesNo(this.confirmText, this.confirmUnselectItem + " " + this.lastBarcode)
							.then((data) => { canRemove = data })
						if (canRemove == true) {
							this.itemsSelected.splice(index, 1);
						}
					}
					else {
						this.itemsSelected.push(foundElement);
					}
				}
			},
			changedTag(value) {
				this.lastTag = value;
			},
			async committedTag() {
				let tagElements = this.lastTag.split('|');
				let foundElement = null;

				switch (tagElements.length) {
					case 0:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnInavlidTAG);
						break;
					case 1:
						this.tablesData.picks.some(pick => {
							if (pick.item.code == this.lastTag) {
								foundElement = pick;
								return true;
							}
						});
						if (!foundElement) this.showMsgWarning(this.messageSearchPackageTitle, this.messageSearchPackageNotFound);
						else if (!this.itemsSelected.includes(foundElement)) this.itemsSelected.push(foundElement);
						break;
					default:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnMultipleTAG);
						break;
				}
			},
			exitPackages() {
				this.$router.push("/package/selection" + 
					"?incoming="+this.isIncoming+
					"&outgoing="+this.isOutgoing+
					"&picking="+this.isPicking+
					"&revision="+this.isRevision+
					"&locked="+this.isLocked
				);
			}
		}
	});
</script>
